import React from "react";
import { Check } from "lucide-react";

interface CheckboxProps {
  checked: boolean;
  disabled?: boolean;
  onChange?: (checked: boolean) => void;
  id?: string;
  name?: string;
}

const Checkbox: React.FC<CheckboxProps> = ({
  checked,
  onChange,
  disabled = false,
  id,
  name,
}) => {
  const handleClick = (event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    if (!disabled && onChange) {
      onChange(!checked);
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === " " || event.key === "Enter") {
      event.preventDefault();
      event.stopPropagation();
      if (!disabled && onChange) {
        onChange(!checked);
      }
    }
  };

  return (
    <div
      role="checkbox"
      aria-checked={checked}
      aria-disabled={disabled}
      tabIndex={disabled ? -1 : 0}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      className={`
        w-5 h-5 rounded-md flex items-center justify-center border cursor-pointer
        transition-colors duration-200 ease-in-out
        ${
          checked
            ? "bg-[#C72BA4] border-[#C72BA4] hover:bg-[#B02395] hover:border-[#B02395]"
            : "border-gray-400 bg-white hover:border-gray-500"
        }
        ${
          disabled
            ? "cursor-not-allowed opacity-50"
            : "focus:outline-none focus:ring-2 focus:ring-[#C72BA4] focus:ring-offset-2"
        }
      `}
    >
      {checked && <Check className="text-white w-3 h-3" strokeWidth={3} />}
      <input
        type="checkbox"
        id={id}
        name={name}
        checked={checked}
        onChange={() => {}}
        disabled={disabled}
        className="sr-only"
        tabIndex={-1}
        aria-hidden="true"
      />
    </div>
  );
};

export default Checkbox;
